import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { webhooksApi, type DeliveryListParams } from '../api/webhooks-api';

import { webhookKeys } from './webhook-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function webhookDeliveriesQueryOptions(
  storeId: string,
  id: string,
  params: DeliveryListParams,
) {
  return queryOptions({
    queryKey: webhookKeys.deliveryList(storeId, id, params),
    queryFn: () => webhooksApi.deliveries(storeId, id, params),
    placeholderData: keepPreviousData,
  });
}

export function useWebhookDeliveries(storeId: string, id: string, params: DeliveryListParams) {
  return useQuery(webhookDeliveriesQueryOptions(storeId, id, params));
}
